import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "Вы уверены что хотите назначить самопривоз?", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_button = _resolveComponent("dw-button")!
  const _component_dw_popup = _resolveComponent("dw-popup")!

  return (_openBlock(), _createBlock(_component_dw_popup, {
    title: "Самопривоз",
    onClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "dw-popup__form",
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
      }, [
        _hoisted_1,
        _createVNode(_component_dw_button, {
          type: "submit",
          loading: _ctx.state.is_loading
        }, {
          default: _withCtx(() => [
            _createTextVNode("Назначить самопривоз")
          ]),
          _: 1
        }, 8, ["loading"])
      ], 32)
    ]),
    _: 1
  }, 8, ["onClose"]))
}